export default function CorreoConfirmadoPage() {
  return (
    <main className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-emerald-50 flex items-center justify-center p-5 text-slate-900">
      <section className="w-full max-w-md rounded-3xl border border-slate-200 bg-white px-7 py-10 shadow-xl text-center">
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-emerald-100">
          <i className="ri-check-line text-5xl text-emerald-600" aria-hidden="true" />
        </div>
        <h1 className="text-3xl font-extrabold tracking-tight">Correo validado</h1>
        <p className="mt-4 text-base leading-7 text-slate-600">
          Tu cuenta fue confirmada correctamente. Ya puedes cerrar esta pestaña y volver a la aplicación para iniciar sesión.
        </p>
        <div className="mt-7 rounded-2xl bg-slate-50 px-4 py-3 text-sm text-slate-500">
          Esta ventana no solicita contraseñas ni información de pago.
        </div>
      </section>
    </main>
  );
}
